<template>
  <div style="width: 22rem;" class="bg-modal" @click.stop>
    <div class="col gap-10">
      <div class="w-full">
        <text-item txt="URL" styles="font-mBold main-l"/>
        <inputBox class="pad-s mtop-02 w-full">
          <!-- @keyup.enter="createNewExternalLink()"-->
          <inputAreaAuto2 ref="focusRef" v-model="linkContent" />
        </inputBox>
      </div>
      <div>
        <button-group styles="pad-m border-l" class="mtop-10" @click="createNewExternalLink()">
          <text-item txt="Créer lien" styles="font-mBold main-h"/>
        </button-group>
      </div>
    </div>
  </div>
</template>




<script setup>
import { ref, onMounted } from 'vue';
import appuserapi from '@/api/appuserapi';

const props = defineProps({
  referenceSheet: {
    type: Object,
    required: true,
  },
})
const emits = defineEmits(['updateClose'])
const focusRef = ref(null)
const linkContent = ref("http://")

async function createNewExternalLink() {
  const appUserResultReferenceId = props.referenceSheet.appUserResultReferenceId
  const link = linkContent.value
  const title = getUrlTitle(link)
  if (!title) {console.error('Invalid URL');return;}
  await appuserapi.addExternalLinkToReferenceSheet(appUserResultReferenceId, title, link)
  emits ('updateClose')
}

function getUrlTitle(url) {
  try {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'http://' + url
    }    
    const parsedUrl = new URL(url)
    const pathParts = parsedUrl.pathname.split('/').filter(part => part)  //the filter part if for eliminating trailing empty slashes like "site/"
    if (pathParts.length < 2) {
      return parsedUrl.hostname
    }
    let title = pathParts.at(-1)
    title = title.replace(/-/g, " ")
    title = title.charAt(0).toUpperCase() + title.slice(1)
    return title
  } catch (error) {
    console.error('Invalid URL:', error)
    return null
  }
}

onMounted(() => {
  focusRef.value.innerRef.select()
})

</script>

<style scoped>
</style>